import axios from '../api/axiosInstance';

export const listCartItems = (customerId) => {
  return axios.get(`/customers/${customerId}/cart`);
};

export const addCartItem = (customerId, data) => {
  return axios.post(`/customers/${customerId}/cart`, data);
};

export const updateCartItem = (customerId, cartItemId, data) => {
  return axios.patch(`/customers/${customerId}/cart/${cartItemId}`, data);
};
